module.exports = __webpack_public_path__ + "static/media/football.37a55af3.atlas";